export const scoreView = {
    "submit_successful": "Bạn đã hoàn thành, chúng tôi sẽ chấm bài sớm nhất",
    "congratulations": "chúc mừng",
    "sorry": "rất tiếc",
    "completed": "hoàn thành",
};
